import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { MatSidenav } from '@angular/material/sidenav';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';
import * as moment from 'moment';

@Component({
  templateUrl: './authzone.component.html',
  styleUrls: [ './authzone.component.css' ]
})
export class AuthzoneComponent implements OnInit {
  @ViewChild('mainMenu') mainMenu: any;

  public userInfo: any = {};
  public rol: any = 0;
  public teletreball: boolean = false;

  entrada() {
    this.tokenStorage.entrada(this.userInfo.id).subscribe(result => 
      this.tokenStorage.regisE = result.res);
  }

  sortida() {
    this.tokenStorage.sortida(this.userInfo.id).subscribe(result => 
      this.tokenStorage.regisS = result.res);
  }

  teletre() {this.teletreball = ! this.teletreball;this.tokenStorage.teletre(this.userInfo.id, this.teletreball).subscribe(result => { return "OK"; })}

  public toggleMenu() {
    if (this.mainMenu.opened)this.mainMenu.close();
    else this.mainMenu.open();
  }

  constructor(public translate: TranslateService, public languageService: LanguageService, public tokenStorage: TokenStorageService, public router: Router) { }
  ngOnInit() {
    this.userInfo = this.tokenStorage.getUser();
    this.rol = this.tokenStorage.getRol();
    this.tokenStorage.darreraES(this.userInfo.id).subscribe(
      result => {
        this.tokenStorage.regisE = result.entrada?moment.utc(result.entrada).format("YYYY-MM-DD HH:mm"):'';
        this.tokenStorage.regisS = result.sortida?moment.utc(result.sortida).format("YYYY-MM-DD HH:mm"):'';
      },
      err => { console.log(err); });
  }

  setLang(lang: string) {
    this.languageService.setLang(lang);
  }
}
